import React , {useState,useEffect,useLocation} from 'react';
import NewPackageAdd from '../../views/PartnerView/NewPackageAdd';

const PartnerPackageAddComponent=()=>{

return(<NewPackageAdd/>);



};
export default PartnerPackageAddComponent;